"use strict";

exports.__esModule = true;
exports.default = void 0;
var _default = {
  "type": "string",
  "enum": ["text", "media", "ekultur"],
  "enumNames": ["Tekst", "Media", "Ekultur"],
  "default": "content"
};
exports.default = _default;
module.exports = exports.default;